import React from 'react';
import { Check } from 'lucide-react';
interface IncludedListProps {
  eyebrow: string;
  heading: string;
  intro?: string;
  items: {
    title: string;
    body: string;
  }[];
}
export function IncludedList({
  eyebrow,
  heading,
  intro,
  items
}: IncludedListProps) {
  return <section className="px-5 md:px-6 py-10 md:py-14 bg-surface" data-id="element-501" data-mp="13vrlbvix232l">
      <div className="max-w-7xl mx-auto" data-id="element-502" data-mp="13v846h13bipm">
        <div className="max-w-2xl mb-6 md:mb-8" data-id="element-503" data-mp="ywwrzznbow48">
          <p className="eyebrow text-brand-blue mb-1" data-id="element-504" data-mp="yxppsb4b0ba8">{eyebrow}</p>
          <h2 className="font-serif text-3xl md:text-[2.6rem] text-ink leading-tight" data-id="element-505" data-mp="u4n6qwx5kk8a">
            {heading}
          </h2>
          {intro && <p className="mt-4 text-lg text-muted-ink leading-relaxed" data-id="element-506" data-mp="p4iksrdh6xao">
              {intro}
            </p>}
        </div>
        <div className="grid sm:grid-cols-2 gap-4" data-id="element-507" data-mp="g6f0tzi528kz">
          {items.map(item => <div key={item.title} className="h-full flex flex-col rounded-2xl bg-background border border-border p-5" data-id="element-508" data-mp="b72h3nmkdhmm">
              <div className="flex items-start gap-4" data-id="element-509" data-mp="20wscvu9bi2x6">
                <span className="shrink-0 mt-0.5 inline-flex items-center justify-center w-9 h-9 rounded-full bg-accent-soft text-accent" data-id="element-510" data-mp="25p3agqgl5cmk">
                  <Check className="w-5 h-5" data-id="element-511" data-mp="1rz9n6ckqb0ey" />
                </span>
                <div data-id="element-512" data-mp="1w01x781fd9ca">
                  <h3 className="font-serif text-xl text-ink" data-id="element-513" data-mp="1vzjovd1hn4o0">{item.title}</h3>
                  <p className="mt-1 text-muted-ink leading-relaxed" data-id="element-514" data-mp="2jpnvzudvxmjr">
                    {item.body}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}